<ion-content class="app-sheet">
  @let documentType = getDocumentTypeLabel(notification);
  @let documentTypeText = documentType.translationKey ? (documentType.translationKey | transloco) : documentType.text;

  <span class="app-tile app-tile--lg app-sheet__tile">
    <app-icon-display
      size=""
      aria-hidden="true"
      [iconType]="'document-lock'" />
  </span>

  <h1 class="app-sheet__title">{{ 'stella.signature.sheetTitle' | transloco }}</h1>

  <p class="app-sheet__body">
    {{ 'stella.signature.request' | transloco }} <b>{{ documentTypeText }}</b>.
  </p>

  <p class="app-sheet__body">
    {{ 'stella.signature.information' | transloco }}
  </p>

  <ion-button
    class="app-cta"
    [disabled]="!notification?.notificationUrl"
    (click)="openExternalWebsiteAsync(notification?.notificationUrl)">
    {{ 'stella.signature.signDocument' | transloco: { documentType: documentTypeText } }}
  </ion-button>
</ion-content>
